import { I18n } from '@calendly/i18n'

import { CustomLocationCard } from './custom_location_card'
import { LocationRowFallback } from './location_row_fallback'
import { useEditableLocationItem } from './use_editable_location_item'

export const CustomLocationItem = ({
  location,
  fieldNamePrefix,
  removeLocation,
  isReadOnly,
  isDisabled,
}) => {
  const isConfirmed = Boolean(location.location?.trim())
  const { isEditing, isNew, startEditing, handleDone, handleCancel } = useEditableLocationItem({
    isConfirmed,
    fieldNamePrefix,
    fields: { location: location.location },
    removeLocation,
  })

  if (isEditing) {
    return (
      <CustomLocationCard
        fieldNamePrefix={fieldNamePrefix}
        subtitle={isNew
          ? I18n.t('publisher.event_type_editor_crud.meeting_details.location.new_custom_location_status')
          : undefined}
        onDelete={removeLocation}
        onCancel={handleCancel}
        onDone={handleDone}
      />
    )
  }

  return (
    <LocationRowFallback
      location={location}
      title={I18n.t('publisher.event_type_editor_crud.meeting_details.location.custom_card_title')}
      subtitle={location.location}
      removeLocation={removeLocation}
      startEditing={startEditing}
      isReadOnly={isReadOnly}
      isDisabled={isDisabled}
    />
  )
}
